import React from 'react'
import Caro from './Client_Carousel'
import "../Assets/styles/clients.css"

const Clients = () => {
  return (
    <>
      <div className="container-lg client-papa">
        <div className="header" data-aos="fade-right" data-aos-duration="1000">
            <span>Testimonial</span> 
            <h3>What Our Clients Say</h3>
        </div>
          <div className="title">
              <Caro/>
          </div>
      </div>
    </>
  )
}

export default Clients